'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BeelineRoutesAppIcon = function BeelineRoutesAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({
    viewBox: "0 0 200 200",
    style: {
      height: props.height,
      width: props.width
    },
    fill: "#6c2f83"
  }, props), React__default["default"].createElement("rect", {
    fill: "#6c2f83",
    width: "200",
    height: "200"
  }), React__default["default"].createElement("path", {
    fill: "#e9b53b",
    d: "M100,51.37c-16.52,0-33.42,13.84-34.34,33.83h68.22C133.24,63.84,116.64,51.37,100,51.37Z"
  }), React__default["default"].createElement("path", {
    fill: "#e9b53b",
    d: "M49.85,99.07H67.51l-.18-.57a40.44,40.44,0,0,1-1.67-13.3H46.24Z"
  }), React__default["default"].createElement("path", {
    fill: "#e9b53b",
    d: "M133.88,85.2a49.43,49.43,0,0,1-1.64,13.87H67.52a83.33,83.33,0,0,0,5.64,13.87h53.59a65.59,65.59,0,0,0,5.5-13.87h18.33l3-13.87Z"
  }), React__default["default"].createElement("path", {
    fill: "#e9b53b",
    d: "M100,146.77a145.71,145.71,0,0,0,18.34-20.52h-37A116,116,0,0,0,100,146.77Z"
  }));
};

var BeelineRoutesAppIcon$1 = iconStyles()(BeelineRoutesAppIcon);

module.exports = BeelineRoutesAppIcon$1;
